import React from 'react';
import { testimonial } from '../data/mock';
import { useLanguage } from '../context/LanguageContext';

const TestimonialsSection = () => {
  const { t, language } = useLanguage();
  
  return (
    <section className="py-16 px-4 bg-teal-500">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
          {t('testimonialsTitle')}
        </h2>
        <h3 className="text-lg md:text-xl text-white/90 mb-10">
          {language === 'es' 
            ? '¿Y tu, estas listo para vivir la Gran Experiencia con nosotros?' 
            : 'Are you ready to live the Great Experience with us?'}
        </h3>

        {/* TripAdvisor Logo */}
        <a
          href="https://www.tripadvisor.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block mb-8"
        >
          <img
            src="https://www.tripadvisor.com/img/cdsi/img2/branding/v2/Tripadvisor_lockup_horizontal_secondary_registered-18034-2.svg"
            alt="TripAdvisor"
            className="h-10 mx-auto"
          />
        </a>

        {/* Testimonial Card */}
        <div className="bg-white rounded-lg p-6 shadow-lg max-w-xl mx-auto">
          <div className="flex items-start gap-4">
            {/* Avatar */}
            <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
              <span className="text-teal-600 font-bold text-lg">
                {testimonial.avatar}
              </span>
            </div>
            
            {/* Content */}
            <div className="text-left">
              <h4 className="font-semibold text-gray-800 text-sm">
                {testimonial.author}
              </h4>
              <p className="text-gray-400 text-xs mb-2">
                {testimonial.date}
              </p>
              <p className="text-gray-600 text-sm">
                {language === 'es' 
                  ? testimonial.content 
                  : 'The best place to get your Tours in Punta Cana, the best 100% experience'}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
